import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { ProductCategory } from "../../Models/Product/ProductCategory";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { CategoryEditContent } from "./Components/CategoryEditContent";
import { Notification } from "../../Components/Notification";
import { CategoryEditTitle } from "./Components/CategoryEditTitle";
import { CollectionItemsPrinter } from "../../Components/Utils/CollectionItemsPrinter";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { Page } from "../Product/Page";


export class ProductsCategoriesEditPage extends Page
{
    constructor(
        private _shop: ShopContentProvider,
        private _blog: BlogContentProvider)
    {
        super("specTeam.pl - Zarządzanie kategoriami produktów", "admin-page");

        this.Content(async (body) =>
        {
            await this._shop.Load();
            await this._blog.Load();

            body.Append(
                new CollectionItemsPrinter(
                    this._shop.Shop.ProductCategories,
                    category => [new CategoryEditTitle(category)],
                    category => [new CategoryEditContent(category, this._blog.Blog.Articles)]),

                new PrimaryButton("➕ Dodaj kategorię")
                    .OnClick(() => this._shop.Shop.ProductCategories.Add(new ProductCategory({ Id: "XXX" }))),

                new PrimaryButton("💾 Zapisz zmiany")
                    .OnClick(async () =>
                    {
                        const result = await this._shop.SaveChanges();
                        new Notification(result.IsSuccess ? "Zmiany zapisane!" : "❌ Problem z zapisaniem zmian", result.ErrorMessage || (result.ContentSize.toFixed(2) + "kb"));
                        window.location.hash = "/";
                    })
            );
        });
    }
}
